function hasSettingValue(value) {
  return value !== null && value !== undefined && String(value).trim() !== ''
}

export default {
  computed: {
    isNetvisorConfigured() {
      return this.settings &&
        hasSettingValue(this.settings.netvisor_customerid) &&
        hasSettingValue(this.settings.netvisor_organizationid) &&
        hasSettingValue(this.settings.netvisor_userkey)
    },
    isBrioxConfigured() {
      return this.settings &&
        hasSettingValue(this.settings.briox_accountid) &&
        hasSettingValue(this.settings.briox_apptoken)
    },
    isNocfoConfigured() {
      return this.settings &&
        hasSettingValue(this.settings.nocfo_token) &&
        hasSettingValue(this.settings.nocfo_business_slug)
    },
    isBrioxSetupVisible() {
      return this.isFeatureEnabled('briox') || this.isBrioxConfigured
    },
    isNocfoSetupVisible() {
      return this.isFeatureEnabled('nocfo') || this.isNocfoConfigured
    },
    settingsTabTitle() {
      return (this.isBrioxSetupVisible || this.isNocfoSetupVisible) ? this._('Netvisor') : this._('Settings')
    },
    isNetvisorAccountingEnabled() {
      return !!(this.settings && parseInt(this.settings.pay_option13))
    },
    isBrioxAccountingEnabled() {
      return !!(this.settings && parseInt(this.settings.pay_option20))
    },
    isNocfoAccountingEnabled() {
      return !!(this.settings && parseInt(this.settings.pay_option21))
    },
    isAccountingConfigured() {
      return this.isNetvisorConfigured ||
        this.isBrioxConfigured ||
        this.isNocfoConfigured ||
        this.isNetvisorAccountingEnabled ||
        this.isBrioxAccountingEnabled ||
        this.isNocfoAccountingEnabled
    },
    isBrioxAccountingMode() {
      if (!this.settings) {
        return false
      }
      if (this.isBrioxAccountingEnabled || this.isNocfoAccountingEnabled) {
        return true
      }
      if (this.isNetvisorAccountingEnabled) {
        return false
      }
      return this.isBrioxConfigured || this.isNocfoConfigured
    },
    isUiFeatureTemplate () {
      return !!(this.settings && parseInt(this.settings.uifeature_template, 10))
    },
    isShipitEnabled() {
      return !!(this.settings && parseInt(this.settings.shipit) && this.settings.shipit_apikey !== '' && this.settings.shipit_apisecret !== '')
    },
    hasStatisticsFinlandCredentials() {
      return !!(this.settings && hasSettingValue(this.settings.statisticsusername) && hasSettingValue(this.settings.statisticspassword))
    },
    // Visma Pay is still stored as Bambora (pay_option9 keys)
    isVismaPaySet() {
      if (!this.settings) {
        return false
      }
      if (hasSettingValue(this.settings.pay_option9_privatekey) && hasSettingValue(this.settings.pay_option9_apikey)) {
        return true
      }
      const saleschannel = this.settings.saleschannel
      return !!(saleschannel && parseInt(saleschannel.defaultcommission, 10) === 0 && parseInt(saleschannel.enabled))
    },
    vats: {
      get () {
        return this.settings && this.settings.vats ? [...new Set([...this.settings.vats.split(';').sort((a, b) => b - a).map(v => parseFloat(v)), 0])] : [0]
      }, 
      set (newValue) {
        this.settings.vats = newValue.join(';')
      }
    },
  },
  methods: {
    isFeatureEnabled(feature) {
      if (!this.settings || !this.settings.features) {
        return false
      }
      const features = this.settings.features.split(';')
      return features.includes(feature)
    }
  }
}